<template>
  <div @click="update" class="footer-small-text">
    <div>Kies je stad :</div>
    <div class="w-dropdown">
      <div class="dropdown-toggle-3 w-dropdown-toggle">
        <div
          :class="'icon-4' + (isSelected ? ' rotate ' : ' ') + 'w-icon-dropdown-toggle'"
        ></div>
        <div class="dropdown-txt-donation">{{ city }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isSelected", "city"],
  created() {},
  methods: {
    update() {
      this.$emit("update")
    },
  },
}
</script>

<style scoped>
.icon-4.rotate {
  transform: rotate(180deg);
}

.footer-small-text {
  cursor: pointer;
}
</style>
